export default import.meta.ROLLDOWN_FILE_URL_n768FgBIF9Qkaoho5LLANg